import { UtilService } from '@services/util/util.service';
import { inject, Component, ViewChild } from '@angular/core';

import { IMainLayoutConfig } from '@models/main-layout.config';
import { VariablesService } from '@services/variables/variables.service';
import { VwoService } from '@services/vwo/vwo.service';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
})
export class MainLayoutComponent {

  public variablesService = inject(VariablesService);
  public utilService = inject(UtilService);
  public vwo = inject(VwoService);

  public config: IMainLayoutConfig;
  isMobile = false;

  constructor() {
    this.variablesService.mainLayoutConfig.subscribe({
      next: res => {
        setTimeout(() => {
          this.config = res;
        }, 0);
      }
    });
  }

  ngOnInit() {
    this.isMobile = this.utilService.isMobile();
  }

  headerLogoClickListner = (data) => {
    this.variablesService.logoOnclik.next(true);
  }

}
